import { Component } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
    selector: "app-background-video",
    template: `<video autoplay muted loop id="myVideo" *ngIf="isDesktop">
        <source
            src="../../../assets/3571264-uhd_3840_2160_30fps.mp4"
            type="video/mp4"
        />
        Your browser does not support HTML5 video.
    </video>`,
    styles: [
        `
            #myVideo {
                position: fixed;
                display: block;
                right: 0;
                bottom: 0;
                min-width: 100%;
                min-height: 100%;
                background-color: #fff;
                opacity: 0.25;
            }
        `,
    ],
    standalone: false,
})
export class BackgroundVideoComponent {
    public isDesktop: boolean = false;

    constructor(private deviceService: DeviceDetectorService) {
        this.isDesktop = this.deviceService.isDesktop();
    }
}
